import {data, h} from '../h'
import {Section} from './index.h'

export const section = (name: Section, cb: () => void) => {
  h('section', () => {
    data({appgrid: name})
    cb()
  })
}
